import { useTheme } from "./ThemeProvider";
import type { ColorOptions } from "./types";

export const useColorScheme = (): [ColorOptions, (colorScheme: ColorOptions) => void] => {
  const { colorScheme, setColorScheme } = useTheme();
  return [colorScheme, setColorScheme];
};
